import { AutocompleteForm } from "modules/common/components/AutocompleteForm";
import InfoCheckmarks from "./InfoCheckmarks/InfoCheckmarks";
import type { HeroFormProps } from "./HeroForm.d";

const HeroForm = ({ ctaVariant = "primary", buttonText = undefined, checkmarks = [] }: HeroFormProps) => (
  <>
    <AutocompleteForm ctaVariant={ctaVariant} buttonText={buttonText} />
    <InfoCheckmarks checkmarks={checkmarks} />
  </>
);

export default HeroForm;
